module.exports = __webpack_public_path__ + "img/61.a411beac.png";